import ResumeCoRegistrationView from './ResumeCoRegistrationView'
export default ResumeCoRegistrationView
